import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../lib/translations';
import { Instagram, Linkedin, Facebook } from 'lucide-react';

const Footer = () => {
  const { lang } = useLanguage();
  const t = translations[lang];

  const memberships = {
    da: [
      {
        name: "Medlem af Dansk Psykolog Forening",
        logo: "https://assets.auxodev.dk/assets/d2a473f1-f23b-48f1-982c-7e943d864f39/image_2.png",
        link: "https://www.dp.dk/"
      },
      {
        name: "Medlem af Mindfulness og Compassion Foreningen Danmark",
        logo: "https://assets.auxodev.dk/assets/d2a473f1-f23b-48f1-982c-7e943d864f39/deabdddf-d4e2-4cf0-998a-61ead6ea5996.png",
        link: "https://mindfulnessforeningen.dk/"
      },
      {
        name: "Registreret med det internationale ACCESS MBCT-register",
        logo: "https://assets.auxodev.dk/assets/d2a473f1-f23b-48f1-982c-7e943d864f39/image_3.png",
        link: "https://www.accessmbct.com/"
      }
    ],
    en: [
      {
        name: "Member of the Danish Psychological Association",
        logo: "https://assets.auxodev.dk/assets/d2a473f1-f23b-48f1-982c-7e943d864f39/image_2.png",
        link: "https://www.dp.dk/"
      },
      {
        name: "Member of the Danish Mindfulness & Compassion Association",
        logo: "https://assets.auxodev.dk/assets/d2a473f1-f23b-48f1-982c-7e943d864f39/deabdddf-d4e2-4cf0-998a-61ead6ea5996.png",
        link: "https://mindfulnessforeningen.dk/"
      },
      {
        name: "Registered with the international ACCESS MBCT register",
        logo: "https://assets.auxodev.dk/assets/d2a473f1-f23b-48f1-982c-7e943d864f39/image_3.png",
        link: "https://www.accessmbct.com/"
      }
    ]
  };

  const activeMemberships = memberships[lang] || memberships.da;

  return (
    <footer className="bg-white">
      {/* Pre-Footer / Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 border-t border-stone-100">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Column 1: Identity */}
          <div className="lg:col-span-4">
            <h3 className="font-serif text-xl text-stone-900 mb-6">
              {lang === 'da' ? 'Klinisk psykolog' : 'Clinical Psychologist'} <br />Kay Elizabeth Worsfold
            </h3>
            <div className="space-y-2 text-sm text-stone-500 leading-relaxed">
              <p>Store Kannikestræde 18, 2. th</p>
              <p>{lang === 'da' ? '1169 København K' : '1169 Copenhagen K'}</p>
              <p className="pt-2">{lang === 'da' ? 'Mail' : 'Email'}: <a href="mailto:info@psykolog-kayworsfold.dk" className="text-stone-700 hover:text-stone-950 underline decoration-stone-300 hover:decoration-stone-950 underline-offset-4 transition-all duration-200">info@psykolog-kayworsfold.dk</a></p>
              <p>{lang === 'da' ? 'Tlf' : 'Phone'}: <a href="tel:+4530463052" className="text-stone-700 hover:text-stone-950 underline decoration-stone-300 hover:decoration-stone-950 underline-offset-4 transition-all duration-200">30463052</a></p>
              <p className="pt-4 text-[10px] uppercase tracking-widest">{t.footer.cvr}</p>
            </div>
          </div>

          {/* Column 2: Memberships */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12 items-start">
              {activeMemberships.map((m, i) => (
                <a 
                  key={i} 
                  href={m.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex flex-col items-center text-center group"
                >
                  <div className="h-12 flex items-center justify-center grayscale group-hover:grayscale-0 transition-all duration-500 mb-2">
                    <img 
                      src={m.logo} 
                      alt={m.name} 
                      className={`max-h-full max-w-full object-contain ${m.logo.includes('image_2.png') ? 'scale-85 origin-center' : ''}`} 
                    />
                  </div>
                  <p className="text-xs text-stone-400 group-hover:text-stone-700 transition-colors leading-normal">
                    {m.name}
                  </p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Absolute Footer */}
      <div className="bg-taupe-500 py-6">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[10px] uppercase tracking-[0.2em] text-taupe-100 text-center md:text-left">
            © {new Date().getFullYear()} {lang === 'da' ? 'Klinisk psykolog' : 'Clinical Psychologist'} Kay Elizabeth Worsfold. {t.footer.rights}.
          </p>
          <Link to="/privatlivspolitik" className="text-[10px] sm:text-[11px] text-taupe-100 hover:text-white transition-colors text-center md:text-right underline underline-offset-4 decoration-taupe-300/30 hover:decoration-white">
            {t.footer.privacy}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
